import bookingViewStyles from '../BookingView/styles';

export default {
    contentContainer: bookingViewStyles.contentContainer,
    superOrder: {
        marginBottom: 10,
    },
};
